import * as React from 'react';
import './edit-survey.scss';
import { Col, Image, Row } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { acceptMediaSurvey, getMediaSurveyById, rejectMediaSurvey } from 'core/repositories/media-survey';
import { API } from 'apis';
import { Button, buttonType } from 'components/button/button';
import { Card } from 'components/card/card';
import { MediaSurveyDetail } from 'core/domain/media-survey/media-survey';
import moment from 'jalali-moment';
import { Enum } from 'core/domain';
import { getViaAuth, responseValidator } from 'apis/api';
import { Page } from 'components/page/page';
import TextArea from 'antd/lib/input/TextArea';
import { digitSperator } from 'core/utils/decimalExtentions';

const { useState, useEffect } = React;

export const SurveyDetails: React.FC = () => {
    // States
    const [approveIsLoading, setApproveIsLoading] = useState<boolean>(false);
    const [rejectIsLoading, setRejectIsLoading] = useState<boolean>(false);
    const [isPageLoading, setIsPageLoading] = useState<boolean>(false);
    const [mediaStateTypes, setMediaStateTypes] = useState<Enum[]>();
    const [surveyData, setSurveyData] = useState<MediaSurveyDetail>();
    const [surveyStateNewData, setSurveyStateNewData] = useState<Enum>();
    const [completeIsLoading, setCompleteIsLoading] = useState(false);
    const [noAnswereIsLoading, setNoAnswerIsLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const surveyId = location.pathname.split('/')[location.pathname.split('/').length - 1];

    async function getMediaSurveysStates() {
        setIsPageLoading(true);
        await getViaAuth(API.survey.manualValidationStates).then((response: any) => {
            setIsPageLoading(false);
            if (responseValidator(response.status)) {
                setMediaStateTypes(response.data);
            }
        });
    }

    async function fetchData() {
        await getMediaSurveyById(setIsPageLoading, setSurveyData, surveyId, setSurveyStateNewData);
        getMediaSurveysStates();
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Page title="جزئیات مدارک کاربر" loading={isPageLoading} className="pmx-dashboard-surveys-edit">
            <Card title="جزئیات  مدارک کاربر">
                {surveyData && (
                    <>
                        <div>
                            <div className="right">
                                <Row>
                                    <span>نام کاربر</span>
                                    <p>
                                        {(surveyData.user.fullName.firstName ?? '') +
                                            ' ' +
                                            (surveyData.user.fullName.lastName ?? '')}
                                    </p>
                                </Row>
                                <Row>
                                    <span>شماره موبایل</span>
                                    <p>{surveyData.user.phoneNumber}</p>
                                </Row>
                                <Row>
                                    <span>کد ملی</span>
                                    <p>{surveyData.user.nationalCode}</p>
                                </Row>
                                <Row>
                                    <span>وضعیت مدرک:</span>
                                    <p
                                        className={`${
                                            surveyData.state.id === 1
                                                ? 'warning'
                                                : surveyData.state.id === 2
                                                  ? 'success'
                                                  : 'error'
                                        }`}
                                    >
                                        {surveyData.state.title}
                                    </p>
                                </Row>
                                <Row>
                                    <span>تاریخ آخرین بررسی:</span>
                                    {surveyData.lastModifiedDate && (
                                        <p>
                                            {moment
                                                .utc(surveyData.lastModifiedDate)
                                                .locale('fa')
                                                .local()
                                                .format('HH:mm - jYYYY/MM/DD')}

                                            {/* {surveyData.modifire && ' توسط '}
                                            {surveyData.modifire} */}
                                        </p>
                                    )}
                                </Row>
                                <Row>
                                    <span>تاریخ ارسال:</span>
                                    {surveyData.createdOn && (
                                        <p>
                                            {moment
                                                .utc(surveyData.createdOn)
                                                .locale('fa')
                                                .local()
                                                .format('HH:mm - jYYY/MM/DD')}
                                        </p>
                                    )}
                                </Row>
                                <Row>
                                    <span>مقدار آخرین خرید</span>
                                    <p>{digitSperator(surveyData.lastBuyOrderAmount)}</p>
                                </Row>
                                <Row>
                                    <span>ویرایش شده توسط</span>
                                    <p>{surveyData.modifiedBy}</p>
                                </Row>
                                <Row>
                                    <Col>
                                        <span>تصاویر مدارک</span>
                                        {surveyData.files.fileByteContent.map((e) => (
                                            <Image src={`data:image/jpeg;base64,${e}`} />
                                        ))}
                                    </Col>
                                </Row>
                                <Row>
                                    <div className="textarea">
                                        <label htmlFor="attachedMessage">توضیحات</label>

                                        <TextArea
                                            disabled={surveyData.state.id !== 1}
                                            name="attachedMessage"
                                            value={surveyData?.attachedMessage}
                                            onChange={(e) =>
                                                setSurveyData({
                                                    ...surveyData,
                                                    attachedMessage: e.target.value,
                                                })
                                            }
                                        />
                                        <div className="texts">
                                            <Button
                                                onClick={(e) =>
                                                    surveyData.state.id === 1 &&
                                                    setSurveyData({
                                                        ...surveyData,
                                                        attachedMessage: 'سن شما مطابق قوانین ما نمیباشد.',
                                                    })
                                                }
                                                type={buttonType.white}
                                                text={'سن غیر مجاز'}
                                            />

                                            <Button
                                                onClick={(e) =>
                                                    surveyData.state.id === 1 &&
                                                    setSurveyData({
                                                        ...surveyData,
                                                        attachedMessage: 'مدارک شما با راهنما سایت مطابقت ندارد.',
                                                    })
                                                }
                                                type={buttonType.white}
                                                text={'عدم تطابق'}
                                            />

                                            <Button
                                                onClick={(e) =>
                                                    surveyData.state.id === 1 &&
                                                    setSurveyData({
                                                        ...surveyData,
                                                        attachedMessage: ' استفاده از مدارک قدیمی',
                                                    })
                                                }
                                                type={buttonType.white}
                                                text={' استفاده از مدارک قدیمی'}
                                            />

                                            <Button
                                                onClick={(e) =>
                                                    surveyData.state.id === 1 &&
                                                    setSurveyData({
                                                        ...surveyData,
                                                        attachedMessage: ' مدارک شما کیفیت کافی جهت بررسی را ندارد.',
                                                    })
                                                }
                                                type={buttonType.white}
                                                text={'کیفیت پائین تصویر'}
                                            />
                                            <Button
                                                onClick={(e) =>
                                                    surveyData.state.id === 1 &&
                                                    setSurveyData({
                                                        ...surveyData,
                                                        attachedMessage: 'سن شما مطابق قوانین ما نمیباشد.',
                                                    })
                                                }
                                                type={buttonType.white}
                                                text={' سن غیر مجاز'}
                                            />
                                        </div>
                                    </div>
                                </Row>
                            </div>
                        </div>
                        <div className={`buttons `}>
                            <Button
                                type={buttonType.info}
                                text="تایید"
                                loading={approveIsLoading}
                                onClick={() =>
                                    acceptMediaSurvey(
                                        setApproveIsLoading,
                                        { id: surveyId, hasFinancialSetting: true },
                                        () =>
                                            getMediaSurveyById(
                                                setIsPageLoading,
                                                setSurveyData,
                                                surveyId,
                                                setSurveyStateNewData,
                                            ),
                                    )
                                }
                            />
                            <Button
                                type={buttonType.info}
                                text="تایید پس از ۷۲ ساعت"
                                loading={approveIsLoading}
                                onClick={() =>
                                    acceptMediaSurvey(
                                        setApproveIsLoading,
                                        { id: surveyId, hasFinancialSetting: true, is72h: true },
                                        () =>
                                            getMediaSurveyById(
                                                setIsPageLoading,
                                                setSurveyData,
                                                surveyId,
                                                setSurveyStateNewData,
                                            ),
                                    )
                                }
                            />
                            <Button
                                type={buttonType.outlined}
                                text="رد"
                                onClick={() =>
                                    rejectMediaSurvey(
                                        setRejectIsLoading,
                                        {
                                            id: surveyId,
                                            message: surveyData.attachedMessage,
                                        },
                                        () =>
                                            getMediaSurveyById(
                                                setIsPageLoading,
                                                setSurveyData,
                                                surveyId,
                                                setSurveyStateNewData,
                                            ),
                                    )
                                }
                                loading={rejectIsLoading}
                            />
                            <Button
                                type={buttonType.outlined}
                                text="تکمیل"
                                onClick={() =>
                                    acceptMediaSurvey(
                                        setCompleteIsLoading,
                                        { id: surveyId, hasFinancialSetting: false },
                                        () =>
                                            getMediaSurveyById(
                                                setIsPageLoading,
                                                setSurveyData,
                                                surveyId,
                                                setSurveyStateNewData,
                                            ),
                                    )
                                }
                                loading={completeIsLoading}
                            />
                            <Button
                                type={buttonType.outlined}
                                text="عدم پاسخ"
                                onClick={() =>
                                    rejectMediaSurvey(
                                        setNoAnswerIsLoading,
                                        { id: surveyId, isAnsweredCall: false },
                                        () =>
                                            getMediaSurveyById(
                                                setIsPageLoading,
                                                setSurveyData,
                                                surveyId,
                                                setSurveyStateNewData,
                                            ),
                                    )
                                }
                                loading={noAnswereIsLoading}
                            />
                        </div>
                    </>
                )}
            </Card>
        </Page>
    );
};
